import { ColumnDef } from '@tanstack/react-table'
import { TransactionMarkAsValues, TransactionStatusValues } from 'types/transaction.type'
import Status from 'features/common/status'
import numeral from 'numeral'
import { dateFormat, datePickerFormat, isDateWithinRange } from 'utils/date-time-utils'
import { ESTIMATE } from './estimate.i18n'

export const CHANGE_ORDER_DEFAULT_VALUE = '0'
export const CHANGE_ORDER_DEFAULT_OPTION = {
  label: '$0.00',
  value: CHANGE_ORDER_DEFAULT_VALUE,
}

export const TRANSACTION_STATUS_OPTIONS = [
  { value: TransactionStatusValues.pending, label: 'Pending' },
  { value: TransactionStatusValues.approved, label: 'Approved' },
  { value: TransactionStatusValues.cancelled, label: 'Cancelled' },
  { value: TransactionStatusValues.denied, label: 'Denied' },
]

export const TRANSACTION_MARK_AS_OPTIONS = {
  paid: {
    value: TransactionMarkAsValues.paid,
    label: 'Paid Back',
  },
  revenue: {
    value: TransactionMarkAsValues.revenue,
    label: 'Revenue',
  },
}
export const TRANSACTION_MARK_AS_OPTIONS_ARRAY = Object.values(TRANSACTION_MARK_AS_OPTIONS)

export const STATUS_SHOULD_NOT_BE_PENDING_ERROR_MESSAGE = 'Status should not be pending'
export const REQUIRED_FIELD_ERROR_MESSAGE = 'This field is required'

export const TRANSACTION_TABLE_QUERIES_KEY = {
  id: 'id.contains',
  type: 'type.contains',
  laborHour: 'laborHour.equals',
  laborCost: 'laborCost.equals',
  material: 'material.equals',
  totalAmount: 'totalAmount.equals',
  status: 'status.equals',
  modifiedDate: 'modifiedDate.lessThanOrEqual',
  approvedBy: 'approvedBy.contains',
}

export const WO_ESTIMATE_TABLE_COLUMNS: ColumnDef<any>[] = [
  {
    header: 'ID',
    accessorKey: 'id',
  },
  {
    header: `Labor Hour`,
    accessorKey: 'totalLaborHours',
  },
  {
    header: 'Labor Cost',
    accessorKey: 'totalVendorLabourCost',
    filterFn: 'includesString',
    accessorFn(cellInfo: any) {
      return cellInfo.totalVendorLabourCost?.toString()
    },
    cell: (row: any) => {
      const value = row.cell.getValue() as string

      return numeral(value).format('$0,0.00')
    },
    meta: { format: 'currency' },
  },
  {
    header: 'Material',
    accessorKey: 'totalVendorMaterial',
    accessorFn(cellInfo: any) {
      return cellInfo.totalVendorMaterial?.toString()
    },
    filterFn: 'includesString',
    cell: (row: any) => {
      const value = row.cell.getValue() as string

      return numeral(value).format('$0,0.00')
    },
    meta: { format: 'currency' },
  },
  {
    header: `${ESTIMATE}.totalAmount`,
    accessorKey: 'totalVendorAmount',
    accessorFn(cellInfo: any) {
      return cellInfo.totalVendorAmount?.toString()
    },
    filterFn: 'includesString',
    cell: (row: any) => {
      const value = row.cell.getValue() as string

      return numeral(value).format('$0,0.00')
    },
    meta: { format: 'currency' },
  },
  {
    header: 'Status',
    accessorKey: 'estimateStatusLabel',
    cell: row => {
      const value = row.cell.getValue() as string
      return <Status value={value} id={value} />
    },
  },
  {
    header: `${ESTIMATE}.submit`,
    accessorKey: 'modifiedDate',
    accessorFn: cellInfo => {
      return datePickerFormat(cellInfo.modifiedDate)
    },
    cell: (row: any) => {
      const value = row?.row.original?.modifiedDate
      return dateFormat(value)
    },
    meta: { format: 'date' },
    filterFn: (row: any, _columnId: string, filterValue: string) => {
      if (row.original.modifiedDate) {
        return isDateWithinRange(row.original.modifiedDate, filterValue)
      }
      return false
    },
  },
]
